'use client'

import { useEffect } from 'react'
import Script from 'next/script'
import { initEnhancedAnalytics, GA4_MEASUREMENT_ID } from '@/lib/analytics'

// GA4 Measurement IDs
const GA4_IDS = [
  GA4_MEASUREMENT_ID, // G-EVXCVZ6T00 (fallback hardcoded)
].filter(Boolean) as string[]

interface AnalyticsProviderProps {
  children: React.ReactNode
  waitForConsent?: boolean
}

export function AnalyticsProvider({ children, waitForConsent = false }: AnalyticsProviderProps) {
  useEffect(() => {
    // Verifica consentimento se necessário
    if (waitForConsent) {
      const consent = localStorage.getItem('cookie-consent')
      if (consent !== 'accepted') {
        // Aguarda consentimento
        const handleConsent = () => {
          const consent = localStorage.getItem('cookie-consent')
          if (consent === 'accepted') {
            initEnhancedAnalytics()
          }
        }
        window.addEventListener('cookie-consent-update', handleConsent)
        window.addEventListener('storage', (e) => {
          if (e.key === 'cookie-consent' && e.newValue === 'accepted') {
            initEnhancedAnalytics()
          }
        })
        return
      }
    }

    // Inicializa analytics
    initEnhancedAnalytics()
  }, [waitForConsent])

  // Se não tem GA4 ID configurado, ainda inicializa o tracking local
  const hasGA4 = GA4_IDS.length > 0 && GA4_IDS[0]

  return (
    <>
      {/* GA4 Script - só carrega se tem ID configurado */}
      {hasGA4 && (
        <>
          <Script
            src={`https://www.googletagmanager.com/gtag/js?id=${GA4_IDS[0]}`}
            strategy="afterInteractive"
          />
          <Script id="ga4-init" strategy="afterInteractive">
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              ${GA4_IDS.map(id => `gtag('config', '${id}', { send_page_view: false });`).join('\n')}
            `}
          </Script>
        </>
      )}
      {children}
    </>
  )
}

/**
 * Hook para tracking manual
 */
export { trackEvent, trackFormStep, trackFormComplete, getVisitorInfo } from '@/lib/analytics'
